import React, { Component } from 'react';
import { connect } from 'react-redux';

import ContentCarousel from './content-carousel';
import { fetchRelatedBlogs, resetBlogListData } from '../../blog-list-actions';
import { isTechAtWork, TECH_AT_WORK_TAG } from '../utils';

const PRIORITY_TAGS_LENGTH_MIN = 5;

class ContentCarouselContainer extends Component {

  constructor(props) {
    super(props);
    this.filters = { templateKey: 'blog', hosted: 'true', blogArchive: 'false' };
    this.sort = { "viewCount": "desc" };
    this.size = 15;
    this.aggregates = {};
    this.aggregateFilters = [];
    this.bucketSize = 15;
    this.postFilters = {};
    this.from = 0;
  }

  componentDidMount() {
    const { tags, relatedBlogs, categories } = this.props;
    const techAtWorkTag = this.getTawTag(tags, categories);
    const queryPostFilters = techAtWorkTag
      ? { tags: [techAtWorkTag] }
      : tags
        ? { tags: tags.slice(0, PRIORITY_TAGS_LENGTH_MIN) }
        : null;
    const { postFilters } = relatedBlogs || {};
    const currentPostFilters = postFilters && JSON.stringify(postFilters);
    const newPostFilters = queryPostFilters && JSON.stringify(queryPostFilters);

    if (relatedBlogs && relatedBlogs.length === 0 && tags && tags.length > 0 && currentPostFilters !== newPostFilters && queryPostFilters) {
      this.props.fetchRelatedBlogs(this.filters, queryPostFilters, this.aggregates, this.aggregateFilters, this.sort, this.size, this.from, this.bucketSize);
    }
  }

  componentWillUnmount() {
    this.props.resetBlogListData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.props.tags || this.props.tags.length === 0) {
      return;
    }

    const prevTags = prevProps.tags.join('');
    const currentTags = this.props.tags.join('');

    const tawTag = this.getTawTag(this.props.tags, this.props.categories);
    const prevTawTag = this.getTawTag(prevProps.tags, prevProps.categories);

    const prevRelatedArticlesLength = prevProps.relatedBlogs && prevProps.relatedBlogs.hits ? prevProps.relatedBlogs.hits.hits.length : 0;
    const currentRelatedArticlesLength = this.props.relatedBlogs && this.props.relatedBlogs.hits ? this.props.relatedBlogs.hits.hits.length : 0;
    const { tags } = this.props;
    const techAtWorkTags = tawTag
      ? { tags: [tawTag] }
      : null;

    const currentPostFilters = this.props.relatedBlogs && this.props.relatedBlogs.postFilters && JSON.stringify(this.props.relatedBlogs.postFilters);

    // switchedToNewBlog - if switching between page without tech-at-work tag, or between pages that have it and don't.
    // hasLowBlogCount - if previous results has less than 15 articles, fetch again using all tags
    let switchedToNewBlog = (prevTags !== currentTags && tawTag === prevTawTag && !tawTag) || (tawTag !== prevTawTag);
    let hasLowBlogCount = prevRelatedArticlesLength !== currentRelatedArticlesLength && currentRelatedArticlesLength < 15 && !tawTag
    let postFilters = techAtWorkTags || { tags: hasLowBlogCount ? tags : tags.slice(0, PRIORITY_TAGS_LENGTH_MIN) };

    if (currentPostFilters !== JSON.stringify(postFilters) && (switchedToNewBlog || hasLowBlogCount)) {
      this.props.fetchRelatedBlogs(this.filters, postFilters, this.aggregates, this.aggregateFilters, this.sort, this.size, this.from, this.bucketSize);
    }
  }

  getTawTag = (tags, categories) => {
    return isTechAtWork(tags, categories)
      ? TECH_AT_WORK_TAG
      : null;
  }

  render() {
    const { header, relatedBlogs = {}, tags } = this.props;

    return (
      <div>
        {
          (relatedBlogs && relatedBlogs.hits && relatedBlogs.hits.hits && relatedBlogs.hits.hits.length > 0) && tags && tags.length > 0 &&
          <ContentCarousel relatedBlogs={relatedBlogs} header={header} />
        }
      </div>

    )
  }

}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchRelatedBlogs: (filters, post_filters, aggregates,
      aggregateFilters, sort, size, from, bucketSize) => dispatch(fetchRelatedBlogs(filters, post_filters, aggregates,
        aggregateFilters, sort, size, from, bucketSize)),
    resetBlogListData: () => dispatch(resetBlogListData())
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    relatedBlogs: state.blogListInfo.relatedBlogs,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContentCarouselContainer);
